import { Link, NavLink } from "react-router-dom";
import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
}

export default function Layout({ children }: Props) {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-nexyo-dark text-white">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 font-semibold text-lg">
            <span className="text-nexyo-primary">⟲</span>
            <span>nexyo · FHIR ↔ OMOP Mapper</span>
          </Link>
          <nav className="flex items-center gap-6">
            <NavLink
              to="/dashboard"
              className={({ isActive }) =>
                isActive ? "text-nexyo-primary" : "text-gray-300 hover:text-white"
              }
            >
              Dashboard
            </NavLink>
            <NavLink
              to="/map"
              className={({ isActive }) =>
                isActive ? "text-nexyo-primary" : "text-gray-300 hover:text-white"
              }
            >
              Sync Mapping
            </NavLink>
            <span className="text-xs text-gray-500 ml-4">lab2</span>
          </nav>
        </div>
      </header>

      <main className="flex-1 max-w-7xl w-full mx-auto px-6 py-8">{children}</main>

      <footer className="bg-white border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-6 py-4 text-sm text-nexyo-muted flex justify-between">
          <span>fhir2omop.health.lab2.nexyo.io · v0.1.0 MVP</span>
          <span>part of nexyo Mapper & Adapter Services</span>
        </div>
      </footer>
    </div>
  );
}
